import type { TipoPessoa } from '@shared/types'

/** Formata CNPJ (14) ou CPF (11) a partir dos dígitos armazenados. */
export function formatDoc(doc: string | null, tipo?: TipoPessoa): string {
  if (!doc) return '—'
  const d = doc.replace(/\D/g, '')
  if (d.length === 14 || tipo === 'PJ') {
    return d.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2}).*/, '$1.$2.$3/$4-$5')
  }
  if (d.length === 11 || tipo === 'PF') {
    return d.replace(/^(\d{3})(\d{3})(\d{3})(\d{2}).*/, '$1.$2.$3-$4')
  }
  return d
}

export function brl(n: number | null | undefined): string {
  if (n == null) return '—'
  return n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
}

export function num(n: number | null | undefined): string {
  if (n == null) return '—'
  return n.toLocaleString('pt-BR')
}
